<div
    [class.fi-modal-content--mobile-view]="isMobile$ | async"
    class="fi-modal-content"
>
    <ng-content></ng-content>
</div>
